import { useTranslation } from "react-i18next";

import { cn } from "@prostocheck/shared";

import { ILoginProgressProps } from "./login-progress.models";

/**
 * Two steps are not worth a stepper widget: a counter, the name of the step
 * and a bar that fills say the same thing in a quarter of the height.
 */
export const LoginProgress = ({ steps, activeStep }: ILoginProgressProps) => {
  const { t } = useTranslation();
  const activeIndex = steps.findIndex(item => item.step === activeStep);

  return (
    <div className="mb-7">
      <div className="flex items-baseline justify-between gap-3 text-xs font-medium">
        <span className="text-brand-700">
          {t("login.stepOf", {
            current: activeIndex + 1,
            total: steps.length,
          })}
        </span>
        <span className="text-ink-500">{t(steps[activeIndex].titleKey)}</span>
      </div>
      <div className="mt-2 flex gap-1.5">
        {steps.map((item, index) => (
          <span
            key={item.step}
            className={cn(
              "h-1 flex-1 rounded-full transition-colors duration-200",
              index <= activeIndex ? "bg-brand-600" : "bg-ink-900/10",
            )}
          />
        ))}
      </div>
    </div>
  );
};
